function productsEndpoint() {
    const finalQuerry = generateQuery()
    const url = `https://aplikace.mimedigital.cz/supporting-endpoints.happy-zoo/?codes${finalQuerry}`
    const xhr = new XMLHttpRequest()
    let hiddenItems = 0
    xhr.open('GET', url)
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const productStocks = JSON.parse(xhr.responseText)

            const products = document.querySelectorAll('.products .product')

            if (products) {
                for (const product of products) {
                    const pCode = product.querySelector('[data-micro="sku"]')?.textContent
                    const inStock = product.querySelector('.availability.in-stock')

                    for (const item of Object.entries(productStocks)) {
                        const itemCode = item[1].code
                        const stockId = item[1].stock.id
                        const stockQty = item[1].amount

                        if (itemCode === pCode && stockId === 1 && stockQty > 0) {
                            product.querySelector(
                                '.availability span:not(.availability-amount)'
                            ).textContent = 'skladem ihned k expedici'
                        }
                    }
                    // if not in stock hide
                    if (!inStock) {
                        product?.closest('.slick-slide')?.classList.add('hide')
                        hiddenItems++
                    }
                }
            }
        }
    }
    xhr.send()

    setTimeout(() => {
        $('.products:not(.p-switchable)').slick(
            'slickSetOption',
            {
                slidesToShow: 4,
                slidesToScroll: 3,
                swipeToSlide: true,
            },
            true
        )

        // Check if there are fewer than four visible items
        var totalSlides = $('.products').find('.slick-slide:not(.hide)').length

        console.log(totalSlides)
        if (totalSlides <= 4) {
            // Remove the slick classes and display the remaining items as regular elements
            $('.products').removeClass('slick-initialized slick-slider slick-dotted')
            $('.products').addClass('slick-remove')
        }
    }, 500)
}

const hideShippingDetail = () => {
    const pcode = getShoptetDataLayer('product').code

    var jsonString = `[{ code: ${pcode}, qty: 1}]`
    var xhr = new XMLHttpRequest()
    xhr.open('POST', 'https://api.dominikp.cz/mimedigital/HappyZoo_dopravy', true)
    xhr.setRequestHeader('Content-type', 'application/json')
    xhr.onload = function () {
        const data = JSON.parse(this.responseText)
        const shippings = document.querySelectorAll('.shipping-row')

        if (shippings) {
            shippings.forEach((item) => {
                const shippingEl = item.querySelector('.shipping-billing-name')

                if (shippingEl) {
                    const shipping = shippingEl.textContent.trim()

                    // hide disabled shipping
                    for (let disabledShipping of data) {
                        if (disabledShipping.dopravce === shipping) {
                            shippingEl.closest('.shipping-row').classList.add('hide')
                        }
                    }

                    // format name
                    if (shipping.includes('#')) {
                        const [formattedName] = shipping.split('#')
                        shippingEl.textContent = formattedName
                    }
                }
            })
        }
    }
    xhr.send(jsonString)
}
const shipping = () => {
    const btn = document.querySelector('.shipping-options')

    if (btn) {
        btn.addEventListener('click', function () {
            const intervalId = setInterval(isModal, 100)

            function isModal() {
                const modal = document.querySelector('.shipping-options-popup')

                if (modal) {
                    clearInterval(intervalId)
                    hideShippingDetail()
                }
            }
        })
    }
}
const hideBtn = () => {
    const isDisable = (keyword) => {
        let param = document.querySelectorAll('.detail-parameters tr')
        let dimValue = ''

        if (param) {
            param.forEach((item) => {
                let paramText = item.querySelector('th .row-header-label')
                let label = paramText?.textContent

                if (label && label.trim() === keyword) {
                    dimValue = item.querySelector('td')?.innerText
                    const value = item.querySelector('td')?.textContent

                    if (Number(value) === 1) {
                        document.querySelector('body').classList.add('disable-buy')
                    }
                }
            })
        }
    }
    // isDisable('Jakostní norma:')

    const isDisabled = document.querySelector('.flag.flag-jakostni-norma')

    if (isDisabled) {
        document.querySelector('body').classList.add('disable-buy')
        const intervalId = setInterval(isCartBtn, 100)

        function isCartBtn() {
            const cartBtn = document.querySelector('.add-to-cart-wrap .add-to-cart-button')

            if (cartBtn) {
                clearInterval(intervalId)
                cartBtn.classList.add('disabled')
                cartBtn.insertAdjacentHTML(
                    'afterend',
                    `<span class = "pickup-only-notice">K zakoupení pouze na kamenné prodejně</span>`
                )

                cartBtn.addEventListener('click', function (event) {
                    event.preventDefault()
                })
            }
        }
    }
}
const renderStockInfo = () => {
    const stocks = getShoptetDataLayer('product')?.codes[0]?.stocks

    if (stocks) {
        stocks.forEach((stock) => {
            if (stock.id === 1 && stock.quantity > 0) {
                const stockQty = stock.quantity
                const root = document.querySelector(':root')
                root.style.setProperty('--pseudo-text', `"skladem ${stockQty} ks ihned k expedici"`)
            }
        })
    }
}
const orderRecap = () => {
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        const orderDialog = document.querySelector('.adv-wrap')

        if (orderDialog) {
            const image = document.querySelector('.p-main-image img')?.src
            const qty = document.querySelector('.add-to-cart-wrap .quantity .amount')?.value
            const title = getShoptetDataLayer('product')?.name
            let price = getShoptetDataLayer('product')?.priceWithVat

            if (qty > 1) {
                price = price * qty
            }

            const productInfoTemplate = `
                    <div class="product-item__information">
                        <div class="product-item__information--image">
                            <img src="${image}" alt="product image">
                        </div>
                        <div class="product-item__information--title">
                            ${title}
                        </div>
                    </div>
            `
            const productAmountTemplate = `
                    <div class="product-item__ammount">${qty} Ks</div>
            `
            const productPriceTemplate = `
                    <div class="product-item__price">${price} Kč</div>
            `

            const template = `
                <div class = "product-item">
                    ${productInfoTemplate}
                    ${productAmountTemplate}
                    ${productPriceTemplate}
                </div>
            `

            orderDialog.insertAdjacentHTML('afterend', template)

            productsEndpoint()
        }
    })
}

const isExpeditionAvailable = () => {
    const intervalId = setInterval(isExpeditions, 100)

    function isExpeditions() {
        const isStock = document.querySelector(
            '.stock-overview .stock-overview__stock:first-child .stock-overview__stock-amount.in-stock'
        )
        if (isStock) {
            clearInterval(intervalId)
            const availability = document.querySelector('.availability-label')

            if (availability) availability.textContent = 'skladem ihned k expedici'
        }
    }
}
const getParam = (keyword) => {
    let param = document.querySelectorAll('.detail-parameters tr')
    let dimValue = ''

    if (param) {
        param.forEach((item) => {
            let paramText = item.querySelector('th .row-header-label')
            let label = paramText?.textContent

            if (label && label.trim() === keyword) {
                dimValue = item.querySelector('td')?.innerText?.trim()
            }
        })
    }
    return dimValue
}
const normaChanges = () => {
    const norma = getParam('Jakostní norma:')
    console.log(norma)

    if (norma === '2') {
        const soldOut = document.querySelector('.sold-out td')

        if (soldOut) {
            soldOut.textContent = soldOut.textContent.replace(
                'Položka byla vyprodána…',
                'Položka je momentálně nedostupná u našeho dodavatele, ale usilovně pracujeme na jejím naskladnění. Děkujeme za pochopení.'
            )
        }
    }
    if (norma === '3') {
        const soldOut = document.querySelector('.sold-out td')
        const availabilityLabel = document.querySelector('.availability-label')

        if (soldOut) {
            soldOut.textContent = soldOut.textContent.replace(
                'Položka byla vyprodána…',
                'Doprodejová položka za akční cenu byla vyprodána. Pokud nebyla položka zrušena dodavatelem, pak bude co nejdříve uvolněna opět do prodeje. Děkujeme za pochopení.'
            )
        }
        if (availabilityLabel) {
           // availabilityLabel.textContent = 'vyprodáno'
        }
    }
}
const sumStockAmounts = () => {
    const stockElements = document.querySelectorAll('.stock-overview__stock-amount.in-stock')
    let totalStock = 0

    stockElements.forEach((element) => {
        const stockText = element.textContent.trim()
        const stockNumber = Number(stockText.match(/\d+/)[0])
        totalStock += stockNumber
    })

    return totalStock
}

const aboveQtyCart = () => {
    const btn = document.querySelector('.add-to-cart-button')
    const norma = getParam('Jakostní norma:')
    let stockAmount = 0

    if (!btn) return
    if (norma !== 'X') return

    setTimeout(() => {
        stockAmount = sumStockAmounts()
    }, 1000)

    btn.addEventListener('click', () => {
        const btnAmount = Number(document.querySelector('.quantity .amount')?.value)

        if (btnAmount > stockAmount) {
            showError(
                'Vložili jste do košíku více kusů, než máme momentálně skladem. Doba expedice Vaší objednávky se tak může prodloužit o počet dní uvedený v detailu produktu.'
            )
        }
    })
}

$(document).ready(function () {
    const isDetail = document.querySelector('.type-detail')

    if (isDetail && !checkUrlForVyhledavani()) {
        renderStockInfo()
        shipping()
        hideBtn()
        orderRecap()
        isExpeditionAvailable()
        const isAdmin = document.querySelector('.admin-bar')
        productsEndpoint()
        normaChanges()
        aboveQtyCart()
    }
})

if($('.type-detail').length){
    if($('#productVideos').length){
        $('#productVideos').prepend('<div class="homepage-group-title h4">Související videa</div>'); 
        $('#productVideos h3').each(function(){
            var $iframe = $(this).next('iframe');
            if($iframe.length > 0) {
                $(this).add($iframe).wrapAll('<div class="iframeWrap"></div>');
                $iframe.wrap('<div class="iframeInner"></div>');
            }
        });
    }

  //  if($('.admin-logged').length){
            var textFriends = '#kamaradi'
            if($('table.detail-parameters tbody tr th').text().trim().includes(textFriends)){
                
                var apiUrl = "https://friends.shopcode.cz/api-variantImagese.php";
                var section = "happyzoo";
                var codes = [];
                $('table.detail-parameters tbody tr').each(function () {
                    var headerText = $(this).find('th span.row-header-label').text().trim();
                    var friendName = $(this).find('td').text().trim();
                    if (headerText.includes(textFriends)) {
                        $(this).closest('tr').hide()
                        codes.push(friendName);
                    }
                });

                if (codes.length === 0) {
                    console.warn("Žádné hodnoty "+textFriends+" nebyly nalezeny.");
                } else {
                    $.ajax({
                        url: apiUrl,
                        type: "GET",
                        data: {
                          section: section,
                          codes: getShoptetDataLayer('product').codes[0].code
                        },
                        dataType: "json",
                        success: function(response) {
                            console.log(response)
                            $(".p-info-wrapper .detail-parameters").after('<div class="friendsSection"><div class="h3">Všechny varianty:</div><div class="inner"></div></div>');
                            response.forEach(function (item) {
                                var sortBy = 'weight';
                                function parseWeightString(str) {
                                    if (!str) return Infinity;
                                    str = str.toLowerCase().replace(',', '.').replace(/\s/g, '').trim();
                                    let match = str.match(/^(\d+)?x?([\d.]+)(kg|g)$/);
                                    if (!match) return Infinity;
                                    let count = parseFloat(match[1]) || 1;
                                    let value = parseFloat(match[2]);
                                    let unit = match[3];
                                    if (isNaN(value)) return Infinity;
                                    let weightInKg = unit === 'g' ? value / 1000 : value;
                                    return count * weightInKg;
                                }
                                if (sortBy === 'weight') {
                                    item.related.sort(function (a, b) {
                                        return parseWeightString(a.kamaradi_hodnoty) - parseWeightString(b.kamaradi_hodnoty);
                                    });
                                } else if (sortBy === 'name') {
                                    item.related.sort(function (a, b) {
                                        return a.name.localeCompare(b.name, 'cs');
                                    });
                                }
                                item.related.forEach(function (itemProduct) {
                                    var nameEscaped = escapeHtmlAttr(itemProduct.name);
                                    var customClass = (document.location.href === itemProduct.url) ? 'active' : '';
                                    var detailHtml = `
                                        <div class="friend ${customClass} show-tooltip" data-title="${nameEscaped}" data-original-title="${nameEscaped}">
                                            <div class="p">
                                                <div class="image">
                                                    <a href="${itemProduct.url}">
                                                        <img src="${itemProduct.image}" alt="${nameEscaped}">
                                                    </a>
                                                </div>
                                                <div class="name"><a href="${itemProduct.url}">${itemProduct.kamaradi_hodnoty}</a></div>
                                            </div>
                                        </div>`;
                                    $(".p-info-wrapper .friendsSection .inner").append(detailHtml);
                                });
                            });
                          
                       
                        },
                        error: function(xhr, status, error) {
                          console.error("Chyba při volání API:", error);
                        }
                        }).done(function(){
                            initTooltips();
                        });
                }

               
    
                function escapeHtmlAttr(text) {
                    return text
                        .replace(/&/g, "&amp;")
                        .replace(/"/g, "&quot;")
                        .replace(/'/g, "&#039;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;");
                }
    
                
              }    
   // }
    

}